<template>
    <v-app>
      <div class="row">
        <div class="col-md-12">
          <div class="kt-portlet kt-portlet--tabs kt-portlet--height-fluid">
            <div class="kt-portlet__head">
              <div class="kt-portlet__head-label">
                <h3 class="kt-portlet__head-title">
                  Gate pass
                </h3>
              </div>
            </div>
            <div class="kt-portlet__body">
              <div class="tab-content">
                <div class="tab-pane active" id="kt_widget4_tab1_content">
                  <div class="kt-widget4">
                    <div class="kt-widget4__item">
                      <div class="kt-widget4__pic kt-widget4__pic--pic">
                        <img src="assets/media/users/100_4.jpg" alt="">
                      </div>
                      <div class="kt-widget4__info">
                        <v-row>
                          <v-col cols="12" lg="11" md="10" sm="12">
                            <v-text-field
                              outlined
                              dense
                              v-model="gatePass.info"
                              @keyup.enter="searchGatePasses"
                              ref="inputField"
                              label="Search by user's CRN number or midas ID or gate pass's bar code"
                            ></v-text-field>
                            <span class="text-danger" v-if="gatePassNotFound">No gate pass found for given credential</span>
                          </v-col>
                        <v-col cols="12" lg="1" md="2" sm="12" class="text-right">
                            <v-btn
                              class="btn btn-primary ml-5 mb-2"
                              @click="searchGatePasses"
                              :loading="gatePassLoading"
                            >
                              Search &nbsp; 
                              <v-icon small elevation="2" outlined>fas fa-search</v-icon>&nbsp;
                            </v-btn>
                          </v-col>
                        </v-row>
                        
                        <div class="mt-2" v-if="!gatePassNotFound && gatePasses.length > 0">
                          <table class="table">
                            <thead>
                              <tr>
                                <th class="px-3 wrap-column">Student</th>
                                <th class="px-3 wrap-column">Issued on</th>
                                <th class="px-2">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="item in gatePasses">
                                <td class="px-3 wrap-column">
                                  {{ item.user_full_name }}
                                  <!-- <div style="max-width: 40px !important; white-space: pre-wrap;">
                                    {{ item.user_email }}
                                  </div> -->
                                </td>
                                <td class="px-3 wrap-column">
                                  {{ item.date_time_formatted }}
                                </td>
                                <td class="px-3 wrap-column">
                                  <b-dropdown size="sm" variant="link"
                                    toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                                    no-caret right no-flip>
                                    <template v-slot:button-content>
                                        <slot>
                                            <span>
                                                <i class="flaticon-more-1"></i>
                                            </span>
                                        </slot>
                                    </template>
                                    <!--begin::Navigation-->
                                    <div class="navi navi-hover ">
                                      <b-dropdown-text tag="div" class="navi-item">
                                        <a href="#" class="navi-link" @click="markAsUsed(item.id)">
                                          <span class="navi-icon">
                                              <i class="fa fa-check-circle"></i>
                                          </span>
                                          <span class="navi-text"> Mark as used </span>
                                        </a>
                                      </b-dropdown-text>
                                      <b-dropdown-text tag="div" class="navi-item">
                                        <a href="#" class="navi-link" @click="viewPdf(item.id)">
                                          <span class="navi-icon">
                                              <i class="fa fa-file-pdf"></i>
                                          </span>
                                          <span class="navi-text"> View PDF </span>
                                        </a>
                                      </b-dropdown-text>
                                    </div>
                                  </b-dropdown>
                                </td>
                              </tr>
                            </tbody>
                          </table>    
                        </div>
                      
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>  
        </div>
      </div>
      <!--end::Dashboard-->
    </v-app>
  
  </template>
  
  <script>
  import GatePassService from "@/core/services/kiosk/gate-pass/GatePassService";
  
  const gatePass = new GatePassService()
  
  export default {
    components: {
    },
    data() {
      return {
        loading: false,
        userNotFound: false,
        gatePassNotFound: false,
        gatePassLoading: false,
        generalAttendance:{
          user_personal_id: null
        },
        gatePass:{
          info: ''
        },
        gatePasses:[],
      };
    },
    computed: {
      user() {
        return this.$store.getters.currentUser;
      },
      currentUser() {
        return this.$store.getters.currentUser;
      },
    },
    mounted(){
      this.setFocusTextField();
    },
    methods: {    
      searchGatePasses(){
          this.gatePassLoading = true;
          gatePass
          .search(this.gatePass)
          .then((res) => {
            this.gatePassNotFound = false;
            this.gatePasses = res.data.gatePasses;
            this.gatePassLoading = false;
          })
          .catch((err) => {
            this.gatePassLoading = false;
            this.gatePassNotFound = true;
          })
      },
  
      markAsUsed(gatePassId){
        this.$confirm({
          message: `Are you sure you want to mark this as used?`,
          button: {
              no: "No",
              yes: "Yes"
          },
          /**
           * Callback Function
           * @param {Boolean} confirm
           */
          callback: confirm => {
              if (confirm) {
                gatePass
                .markAsUsed(gatePassId)
                .then(response => {
                    this.$snotify.success('Successfully marked as used');
                    this.gatePasses = [];
                    this.gatePassNotFound = false;
                    this.getGatePasses();
                })
                .catch(error => {
                });
              }
          }
        });
      },
  
      getGatePasses(){
          this.gatePassLoading = true;
          gatePass
          .search(this.gatePass)
          .then((res) => {
            this.gatePasses = res.data.gatePasses;
            this.gatePassLoading = false;
          })
          .catch((err) => {
            this.gatePassLoading = false;
          })
      },
  
      viewPdf(gatePassId){
        gatePass
        .print(gatePassId)
      },

      setFocusTextField(){
        this.$nextTick(() => {
          this.$refs.inputField.focus();
        });
      }
    }
  }
  </script>
  
  <style scoped>
  .theme--light.v-application {
    background: none !important;
    /*color: rgba(0, 0, 0, 0.87);*/
  }
  .wrap-column{
    max-width: 80px !important; 
      white-space: pre-wrap;
  }
  </style>
  
  